document.querySelectorAll( '.b-hero-video' ).forEach( ( block ) => {

	block.querySelector( '.b-hero-video__btn' )?.addEventListener( 'click', ( e ) => {

		e.preventDefault();
		const videoUrl = e.target.getAttribute( 'data-popup-video' );
		if ( videoUrl ) {

			createVideoPopup( videoUrl, e.target.getAttribute( 'data-popup-exit' ) );

		}

	} );

} );




/**
 *
 * Creates and displays a video popup
 *
 *	@param {string} videoUrl URL of the video to display
 *	@param {string} exitText Text for the exit button
 */
function createVideoPopup( videoUrl, exitText = 'Go back' ) {

	// Remove any existing popup
	const oldPopup = document.querySelector( '.video-popup' );
	if ( oldPopup ) {

		oldPopup.remove();

	}

	// Create popup elements
	const popup = document.createElement( 'div' );
	popup.className = 'video-popup';

	const exit = document.createElement( 'div' );
	exit.className = 'video-popup__exit';
	exit.textContent = exitText;

	const exitBtn = document.createElement( 'button' );
	exitBtn.textContent = '';
	exitBtn.innerHTML = `
		   <svg width="16" height="16" viewBox="0 0 16 16"
		    xmlns="http://www.w3.org/2000/svg">
<path d="M8.08073 3.60921L4.55208 7.13786H14.276V8.47119H4.55208L8.08073 11.9998L7.13802 12.9425L2 7.80452L7.13802 2.6665L8.08073 3.60921Z"/>
</svg>
	   `;
	exit.appendChild( exitBtn );

	const inner = document.createElement( 'div' );
	inner.className = 'video-popup__inner';

	const video = document.createElement( 'video' );
	video.src = videoUrl;
	video.controls = true;
	video.autoplay = false;

	inner.appendChild( video );
	popup.appendChild( exit );
	popup.appendChild( inner );

	document.body.appendChild( popup );
	document.documentElement.style.overflow = 'hidden';

	// Close popup on exit click
	exit.addEventListener( 'click', () => {

		popup.remove();
		document.documentElement.style.overflow = '';

	} );

	// Optional: close on outside click
	popup.addEventListener( 'click', ( e ) => {

		if ( e.target === popup ) {

			popup.remove();
			document.documentElement.style.overflow = '';

		}

	} );

}

